import type { SourceFile } from "../sidebar/sources-types";
import {
    DATA_BANK_VIEW_CASTE_SUMMARY,
    DATA_BANK_VIEW_CONSTITUENCY_MAP,
} from "../sidebar/add-source/dataBankViewTypes";
import { resolveDataBankViewType } from "./dataBankSourceHelpers";
import DataBankCasteSummaryPanel from "./DataBankCasteSummaryPanel";
import DataBankConstituencyMapPanel from "./DataBankConstituencyMapPanel";
import DataBankSourceElectionPanel from "./DataBankSourceElectionPanel";
import { DataBankViewErrorBoundary } from "./DataBankViewErrorBoundary";

type Props = { file: SourceFile };

export default function DataBankAnalyticsPanel({ file }: Props) {
    const viewType = resolveDataBankViewType(file);
    if (viewType === DATA_BANK_VIEW_CASTE_SUMMARY) {
        return (
            <DataBankViewErrorBoundary label="caste summary">
                <DataBankCasteSummaryPanel file={file} />
            </DataBankViewErrorBoundary>
        );
    }
    if (viewType === DATA_BANK_VIEW_CONSTITUENCY_MAP) {
        return (
            <DataBankViewErrorBoundary label="constituency map">
                <DataBankConstituencyMapPanel file={file} />
            </DataBankViewErrorBoundary>
        );
    }
    return (
        <DataBankViewErrorBoundary label="election results">
            <DataBankSourceElectionPanel file={file} />
        </DataBankViewErrorBoundary>
    );
}
